import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { apiHost } from '../helper/apiHost';

const DEFAULT_FAVICON = `${process.env.PUBLIC_URL || ''}/favicon.png`;

export function useWebsiteFavicon(token) {
    const [faviconUrl, setFaviconUrl] = useState(DEFAULT_FAVICON);
    const [loading, setLoading] = useState(true);

    const loadFavicon = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get('api/website-settings/favicon', {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                withCredentials: true,
            });
            if (res.data?.url) {
                setFaviconUrl(`${apiHost}${res.data.url}?t=${Date.now()}`);
            } else {
                setFaviconUrl(DEFAULT_FAVICON);
            }
        } catch {
            setFaviconUrl(DEFAULT_FAVICON);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        loadFavicon();
    }, [loadFavicon]);

    useEffect(() => {
        const handleFaviconUpdated = () => loadFavicon();
        window.addEventListener('website-favicon:updated', handleFaviconUpdated);
        return () => window.removeEventListener('website-favicon:updated', handleFaviconUpdated);
    }, [loadFavicon]);

    return { faviconUrl, loading, reloadFavicon: loadFavicon };
}
